import { NavLink } from '@remix-run/react';
import { FC } from 'react';
import styled from 'styled-components';
import navigationItems from '~/common/constants/navigation';
import { Routes } from '~/common/constants/routes';
import { NAV_ICONS_ABBREVIATIONS_TO_NAMES } from '~/components/navigations/NavigationItems';
import { Box } from '~/components/wrappers/Box';
import { Flex } from '~/components/wrappers/Flex';
import useColor from '~/recoil/useColor';
import { Colors } from '~/theme';

interface IDesktopSidebar {
  fontColor?: Colors;
  activeTab?: string;
}

const DesktopSidebar = ({ fontColor, activeTab }: IDesktopSidebar) => {
  const { color } = useColor();

  return (
    <StyledFlex activeTab={activeTab} color={color}>
      {navigationItems.map((item) => {
        const IconComponent = NAV_ICONS_ABBREVIATIONS_TO_NAMES[
          item.title as keyof typeof NAV_ICONS_ABBREVIATIONS_TO_NAMES
        ] as FC<{ fontColor?: string; active?: boolean }>;

        return (
          <Box key={item.title}>
            <NavLink to={item.location}>
              {IconComponent ? (
                <IconComponent
                  fontColor={color ? 'white' : fontColor}
                  active={activeTab === item.location}
                />
              ) : null}
            </NavLink>
          </Box>
        );
      })}
    </StyledFlex>
  );
};
export default DesktopSidebar;

const StyledFlex = styled(Flex)<{ activeTab?: string; color?: string }>`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  gap: 2rem;
  padding: 0.75rem 2.5rem 1.5rem;
  background-color: ${({ theme, activeTab, color }) =>
    activeTab === Routes.Home
      ? 'transparent'
      : color
      ? color
      : theme.colors.white};
`;
